module.exports = __webpack_public_path__ + "img/SInvoice.bda6975c.svg";